import '../styles/index.css'
import 'react-toastify/dist/ReactToastify.css';

import { useEffect, useCallback } from 'react';
import Router, { NextRouter, useRouter } from 'next/router';
import type { AppProps, NextWebVitalsMetric} from 'next/app';

import { GoogleAnalytics, usePageViews, event } from "nextjs-google-analytics";

import { ToastContainer, toast } from 'react-toastify';

// import Auth from '../modules/auth/Auth'
import LayoutSelector from '../layouts'

import { setRouterHistory } from '@/modules/nextjs/routerHistory.csr'

function App({ Component, pageProps }: AppProps) {
  usePageViews();
  const Router = useRouter();
  const Layout = LayoutSelector()

  // 무조건 처음 앱 진입 시 실행. 이후 router.asPath가 바뀐 이후에 실행.
  useEffect(() => setRouterHistory(Router), [Router]);

  return (
    <>
    {/* <RecoilRoot> */}
      <GoogleAnalytics strategy="lazyOnload" />
      <Layout {...pageProps}>
        <Component {...pageProps} />
      </Layout>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    {/* </RecoilRoot> */}
    </>
  )
}

export function reportWebVitals(metric: NextWebVitalsMetric) {
  const { id, name, label, value } = metric;
  event(name, {
    category: label === "web-vital" ? "Web Vitals" : "Next.js custom metric",
    value: Math.round(name === "CLS" ? value * 1000 : value), // values must be integers
    label: id, // id unique to current page load
    nonInteraction: true, // avoids affecting bounce rate.
  });
}

export default App
